import { Component } from '@angular/core';
export var NgbModalBackdrop = (function () {
    function NgbModalBackdrop() {
    }
    NgbModalBackdrop.decorators = [
        { type: Component, args: [{ selector: 'ngb-modal-backdrop', template: '', host: { 'class': 'modal-backdrop fade in' } },] },
    ];
    /** @nocollapse */
    NgbModalBackdrop.ctorParameters = [];
    return NgbModalBackdrop;
}());
//# sourceMappingURL=modal-backdrop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.js
// module id = 171
// module chunks = 1